import React, { useEffect, useState, FC } from 'react';
import Service from '../Service';

import st from './ServicesList.module.css';

const SEARCH_RESULTS_CHUNK_SIZE = 8;

const shouldShowMoreButton = (services, showServicesCount) =>
  services.length > SEARCH_RESULTS_CHUNK_SIZE &&
  showServicesCount <= services.length;

type ServicesListProps = {
  services: [
    {
      id: number;
      name: string;
      officesIds: [number];
    }
  ];
  office?: any;
  onClose: () => void;
};

const ServicesList: FC<ServicesListProps> = ({ services, office, onClose }) => {
  const [sliceSize, setSliceSize] = useState(SEARCH_RESULTS_CHUNK_SIZE);
  const [visibleFullInfoId, setVisibleFullInfoId] = useState(null);
  const onShowMore = () => {
    setSliceSize(sliceSize + SEARCH_RESULTS_CHUNK_SIZE);
  };
  const onFullInfoShow = (serviceId) => {
    setVisibleFullInfoId(visibleFullInfoId === serviceId ? null : serviceId);
  };
  useEffect(() => {
    setVisibleFullInfoId(null);
  }, [services]);

  return (
    <ul data-testid="catalogList">
      {/* @ts-ignore */}
      {services.length === 0 ? (
        <div>Ничего не найдено</div>
      ) : (
        services.slice(0, sliceSize).map((service) => (
          <li className={st.item} key={service.id}>
            <Service
              fullInfoVisible={visibleFullInfoId === service.id}
              name={service.name}
              office={office}
              officesIds={service.officesIds}
              serviceId={service.id}
              onClose={onClose}
              onFullInfoShow={onFullInfoShow}
            />
          </li>
        ))
      )}
      {shouldShowMoreButton(services, sliceSize) && (
        <li>
          <button
            type="button"
            className={st.moreButton}
            data-testid="catalogShowMoreButton"
            onClick={onShowMore}
          >
            Показать еще
          </button>
        </li>
      )}
    </ul>
  );
};

export default ServicesList;
